import ChooseYourPathBg from "../../assets/img/home-choose-your-path-bg.png";
import { Link } from "react-router-dom";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const Item = ({ title, descriptions, link }: { title: string, descriptions: string[], link: string }) => {
    return <div className={clsx(
        "bg-white/1 backdrop-blur-[40px] rounded-[24px] p-[40px] relative z-[2] border border-white/10 flex flex-col gap-[46px] w-full",
        "md:w-[442px]"
    )}>
        <div className={clsx(
            "text-start text-[42px] font-mdeium leading-[1.2] tracking-[-1.68px]",
            "md:font-semibold"
        )}>{title}</div>
        <div>
            {descriptions.map((description, index) => (
                <div key={index} className="truncate text-[16px] font-normal leading-[1.2] tracking-[-0.64px] flex items-center gap-[4px]">
                    <div className="w-[6px] h-[6px] rounded-full bg-white" />
                    {description}
                </div>
            ))}
        </div>
        <Link to={link}>
            <button className="px-[40px] py-[24px] rounded-[100px] border-btn text-[16px] font-medium transition-all duration-300 leading-[1.2]">
                Start Earning→
            </button>
        </Link>
    </div>;
};

const ChooseYourPath = () => {
    return <div className={clsx(
        "relative flex flex-col items-center gap-[40px] pt-[40px] pb-[40px] border-b border-[#161616] px-[16px]",
        "md:pt-[120px] md:pb-[80px]"
    )}>
        <img src={ChooseYourPathBg} alt="ChooseYourPath" className="absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%] w-full h-[70%] object-cover max-w-[424px]" />
        <AnimatedContent className="relative z-[3]">
            <div className="text-center text-[46px] font-semibold leading-[1.2] tracking-[-1.84px]">
                Choose your path
            </div>
        </AnimatedContent>
        <div className={clsx(
            "flex flex-col gap-[16px]",
            "md:flex-row"
        )}>
            <Item
                title="Earn Yield"
                descriptions={[
                    "Auto-staked to root subnet",
                    "25% share of every winning trade",
                    "Withdraw anytime"
                ]}
                link="/depositor"
            />
            <Item
                title="Trade with Power"
                descriptions={[
                    "Borrow up to 10x collateral",
                    "Stake/unstake alpha instantly",
                    "Keep 70% of profits"
                ]}
                link="/trader"
            />
        </div>
    </div >;
};

export default ChooseYourPath;
